import DesCatalogPartSummaryViewModel from 'viewmodel/DesCatalogPartSummaryViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';
import { DesAccConstants } from '../constant/desAccConstants';

export default class DesCatalogPartSummary extends DesBaseCatalogAcc {
    constructor() {
        super(DesCatalogPartSummaryViewModel);
    }

    get partId() {
        return this.getAttribute(DesAccConstants.PART_ID);
    }

    get attachments() {
        return this.getAttribute(DesAccConstants.ATTACHMENTS);
    }

    getProps() {
        return {
            attachments: this.attachments,
            catalogspaceid: this.catalogspaceId,
            hideelements: this.hideElements,
            partid: this.partId,
            provider: this.provider
        };
    }

    static get observedAttributes() {
        return [
            ...DesBaseCatalogAcc.observedAttributes,
            DesAccConstants.ATTACHMENTS,
            DesAccConstants.PART_ID,
            DesAccConstants.HIDE_ELEMENTS
        ];
    }
}

if (!window.customElements.get('des-catalog-part-summary')) {
    window.customElements.define('des-catalog-part-summary', DesCatalogPartSummary);
}
